import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ProductResponseModel } from 'src/app/models/Home/home-list.model';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { AccessoriesProductList, UpdateAccessoriesProduct, UpdateAccessoriesProductModel } from 'src/app/models/product/accessories.model';
import { ProductListingModel, RelatedProductList } from 'src/app/models/product/productListing.modal';
import { ProductNameComponent } from 'src/app/modules/layoutShopModule/shop-components/product-name/product-name.component';
import { AlertifyService } from 'src/app/services/Common/alertify.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { ProductService } from 'src/app/services/product.service';
import { AccessoriesProductsDeletedComponent } from '../accessories-products-deleted/accessories-products-deleted.component';

@Component({
  selector: 'app-accessories-products',
  templateUrl: './accessories-products.component.html',
  styleUrls: ['./accessories-products.component.css']
})
export class AccessoriesProductsComponent implements OnInit {
  Loader: boolean = false;
  productlisting: ProductListingModel = new ProductListingModel();
  filteredCategories: Array<string> = [];
  searchValue: string = "";
  productId: string;
  checkedAccessoriesProductItems: Array<AccessoriesProductList>;
  ProductId: number;
  productResponseModel: ProductResponseModel;
  totalPages: number;
  accessoriesProductIds: string;
  accessoriesProductItems: Array<AccessoriesProductList>
  updateAccessoriesProduct = new UpdateAccessoriesProduct();
  selectedId: any;
  getCategories: [];
  pagingModel: PagingModel = new PagingModel();
  updateAccessoriesProductModel: UpdateAccessoriesProductModel = new UpdateAccessoriesProductModel();
  


  constructor(private productService: ProductService,  private modalService: NgbModal, private homePageService: HomePageService, private alertify: AlertifyService, private route: Router, private router: ActivatedRoute) { 
    this.productResponseModel = new ProductResponseModel();
    this.accessoriesProductItems = new Array<AccessoriesProductList>();
    this.checkedAccessoriesProductItems = new Array<AccessoriesProductList>();
    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
  }

  ngOnInit() {
    this.router.params.subscribe((param) => {
      this.productId = param.id;
    })
    this.router.params.subscribe((param) => {
      this.accessoriesProductIds = param.id;
    })
    this.accessoriesProductListing();
    this.getAllCategories();
  }

  getAllCategories() {
    this.productService.getCategories().subscribe(response => {
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.getCategories = responseBody.responseData;
      }
    });
  }

  resetFilter() {
    this.searchValue = "";
    this.filteredCategories = [];
    this.getAllCategories();
    this.accessoriesProductListing();
  }

  loadPage(pagingModel: PagingModel) {
    this.productlisting.PageNumber = pagingModel.pageNumber;
    this.productlisting.PageSize = pagingModel.pageSize;
    this.accessoriesProductListing();
  }

  filter() {
    this.productlisting.KeyWord = this.searchValue;
    this.productlisting.CategoryIds = this.filteredCategories.join(",");
    this.accessoriesProductListing();
  }

  accessoriesProductListing() {
    this.Loader = true;
    this.productlisting.CategoryIds = this.filteredCategories.join(",");
    this.productlisting.KeyWord = this.searchValue;
    this.productlisting.ProductId = this.productId;
    this.productService.accessoriesProductsListing(this.productlisting).subscribe(response => {
      this.Loader = false;
      var responseBody = JSON.parse(response._body);
      if (responseBody.isSuccess) {
        this.getAccessoriesProduct();
        this.accessoriesProductItems = [];
        this.productResponseModel.ProductSort = responseBody.responseData;
        for (var i = 0; i < responseBody.responseData.length; i++) {
          var item = responseBody.responseData[i];
          var productItems = new RelatedProductList();
          productItems.id = item.productId;
          productItems.productName = item.productName;
          productItems.priceFormatted = item.productPriceFormatted;
          productItems.categoryNames = item.categoryNames;
          productItems.isSelected = false;
          this.accessoriesProductItems.push(productItems);
        }
        this.accessoriesProductItems.forEach((element, index) => {
          this.accessoriesProductItems[index].imageLoader = true;
          this.ProductId = element.id;
          this.homePageService.ProductImageList(this.ProductId)
            .subscribe((response) => {
              let responseimage = JSON.parse(response._body)
              if (responseimage.isSuccess) {
                this.accessoriesProductItems[index].productImage = responseimage.responseData;
                this.accessoriesProductItems[index].imageLoader = false;
              }
              (err) => {
                this.Loader = false;
              }
            })
        });
        this.productResponseModel.TotalPages = responseBody.totalPages;
        this.totalPages = this.productResponseModel.TotalPages == undefined ? 0 : this.productResponseModel.TotalPages;
      }
      else {
        this.Loader = false;
      }
    })
  }


  setSelectedRelatedProducts(item: AccessoriesProductList, event) {
    for (var j = 0; j < this.accessoriesProductItems.length; j++) {
      if (this.accessoriesProductItems[j].id == item.id) {
        this.accessoriesProductItems[j].isSelected = !this.accessoriesProductItems[j].isSelected;
        this.selectedId = item.id;
        break;
      }

    }
  }

  onSubmit() {
    this.Loader = true;
    this.updateAccessoriesProduct.ProductId = this.productId;
    this.updateAccessoriesProduct.AccessoriesProductIds = this.selectedId;
    var accessoriesId = [];
    for (var j = 0; j < this.accessoriesProductItems.length; j++) {
      if (this.accessoriesProductItems[j].isSelected) {
        accessoriesId.push(this.accessoriesProductItems[j].id.toString());
      }
    }
    this.updateAccessoriesProduct.AccessoriesProductIds = accessoriesId.toString();
    this.productService.updateAccessoriesProducts(this.updateAccessoriesProduct)
      .subscribe((response) => {
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        if (responseBody.isSuccess) {
          this.alertify.success(responseBody.responseData);
          this.accessoriesProductListing();
        }
        else {
          this.alertify.error(responseBody.responseMessage);
        }
        this.Loader = false;
      });
  }

  getAccessoriesProduct() {
    this.Loader = true;
    this.updateAccessoriesProductModel.ProductId = +this.productId;
    this.productService.getAccessoriesProductId(this.updateAccessoriesProductModel.ProductId)
      .subscribe((response) => {
        this.checkedAccessoriesProductItems = [];
        var responseBody = JSON.parse(response._body);
        this.Loader = false;
        for (var i = 0; i < responseBody.responseData.length; i++) {
          var item = responseBody.responseData[i];
          var accessoriesProductItems = new AccessoriesProductList();
          accessoriesProductItems.id = item.id;
          accessoriesProductItems.productTitle = item.productTitle;
          accessoriesProductItems.priceFormatted = item.productPriceFormatted;
          accessoriesProductItems.discount = item.discountPercent;
          accessoriesProductItems.isSelected = false;
          this.checkedAccessoriesProductItems.push(accessoriesProductItems);
        }
        this.checkedAccessoriesProductItems.forEach((element, index) => {
          this.checkedAccessoriesProductItems[index].imageLoader = true;
          this.ProductId = element.id;
          this.homePageService.ProductImageList(this.ProductId)
            .subscribe((response) => {
              let responseimage = JSON.parse(response._body)
              if (responseimage.isSuccess) {
                this.checkedAccessoriesProductItems[index].productImage = responseimage.responseData;
                this.checkedAccessoriesProductItems[index].imageLoader = false;
              }
              (err) => {
                this.Loader = false;
              }
            })
        });
      });
  }

  singleAccessoriesProductDelete(item) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "lg";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    this.productService.passProductId(item.id);
    let modalRef = this.modalService.open(AccessoriesProductsDeletedComponent, modalConfig);
    modalRef.componentInstance.ProductId = item.id;
    modalRef.result.then(() => {
    }, (reason) => {
      this.accessoriesProductListing();
    });
}

productImage(item) {
  const url = this.route.serializeUrl(
    this.route.createUrlTree(['/product-page/' + item.id]));
  window.open('#' + url, '_blank');
}

shopProductName(item) {
  var modalConfig = new NgbModalConfig();
  modalConfig.size = "sm";
  modalConfig.centered = true;
  modalConfig.backdrop = false;
  modalConfig.keyboard = false;
  let modalRef = this.modalService.open(ProductNameComponent, modalConfig);
  modalRef.componentInstance.productTitle = item.productTitle;
}
}
